<template>
  <div v-loading="infoLoading">
    <ContentHeader path-set-type="replace" />

    <div class="content-container">
      <!-- 订单基本信息 -->
      <OrderBaseInfo
        :tradeApplyOrderVO="tradeApplyOrderVO"
        :tradeApplyInfoVO="tradeApplyInfoVO"
        :tradeApplyBaseVO="tradeApplyBaseVO"
        :isMineApply="isMineApply"
        @handleSuccess="init"
      >
        <!-- 订单状态进度 -->
        <OrderStepInfo ref="OrderStepInfo" :tradeApplyOrderVO="tradeApplyOrderVO" />
      </OrderBaseInfo>

      <!-- 订单明细 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(0)"><i :class="[orderShow ? 'el-icon-minus' : 'el-icon-plus']"></i> 订单明细</div>
        <div v-show="orderShow">
          <!-- 门店基础信息 -->
          <StoreCoolerInfo
            ref="StoreCoolerInfo"
            :tradeApplyOrderVO="tradeApplyOrderVO"
            :tradeApplyInfoVO="tradeApplyInfoVO"
            :tradeApplyBaseVO="tradeApplyBaseVO"
            :coolerInfo="coolerInfo"
            :afterPocInfo="afterPocInfo"
            :basePocInfo="basePocInfo"
            :entryCode="entryCode"
          />
        </div>
      </div>

      <!-- 操作记录 -->
      <div class="order-info">
        <div class="info-title" @click="collClick(1)"><i :class="[processShow ? 'el-icon-minus' : 'el-icon-plus']"></i> 操作记录</div>
        <div v-show="processShow">
          <OrderProcessInfo ref="OrderProcessInfo" :processRecordList="processRecordList" />
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="order-info info-btn" v-if="showButton">
        <div :class="{ fixed: isFixed }">
          <el-button class="btn-red-plain" size="small" @click="handleReject">驳回</el-button>
          <el-button class="btn-red" size="small" @click="handlePass">通过</el-button>
        </div>
      </div>

      <!-- 通过弹窗 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" style="min-width: 430px">
        <div class="dialog-data">
          <div class="title">是否确认审批通过</div>
          <div v-if="entryCode != '113'" class="color-red">
            <div class="title">请确认以下押金退还信息是否准确</div>
            <div>待退还金额 {{ coolerInfo.pledgeAmount }}</div>
            <div>押金退还人 {{ coolerInfo.paidContactPerson || '暂无' }} {{ coolerInfo.paidContactPhone || '暂无' }}</div>
            <div>区域TM经理审批通过后将由系统返还押金</div>
          </div>
        </div>
        <span slot="footer" class>
          <el-button type="danger" plain @click="dialogVisible = false">取 消</el-button>
          <el-button :loading="btnLoading" type="danger" @click="confirmPass">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 驳回弹窗 -->
      <el-dialog title="提示" :visible.sync="rejectVisiable" width="30%" style="min-width: 430px">
        <el-form :model="approveParams" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="填写驳回理由" prop="desc">
            <el-input type="textarea" v-model="approveParams.processRemark" :rows="2" placeholder="请填写驳回理由"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class>
          <el-button type="danger" plain @click="rejectVisiable = false">取 消</el-button>
          <el-button :loading="btnLoading" type="danger" @click="confirmReject">驳回</el-button>
        </span>
      </el-dialog>

      <!-- 成功弹窗 -->
      <el-dialog title="提示" :visible.sync="succVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <span>{{ successText }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="returnList">返回</el-button>
          <el-button class="btn-red" size="small" @click="showInfo">查看详情</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import orderApi from "@/api/order"
import tradeApi from '@/api/trade.js'
import ContentHeader from "@/components/content-header"
import OrderBaseInfo from "./components/order-base-info"
import OrderStepInfo from "./components/order-step-info"
import StoreCoolerInfo from "./components/store-cooler-info"
import OrderProcessInfo from "./components/order-process-info"
export default {
  name: "trade-cooler-order-info",
  components: {
    ContentHeader,
    OrderBaseInfo,
    OrderStepInfo,
    StoreCoolerInfo,
    OrderProcessInfo
  },
  data () {
    return {
      approveParams: {
        applyId: "",
        approvalType: "01", //01需求审批 02费用审批 03验收审批
        approvalResult: "", //03 驳回 02 通过
        processRemark: "" //审批信息
      }, //提交审核参数

      showButton: false, //是否显示审批按钮
      afterPocInfo: {},
      coolerInfo: {},
      entryCode: "",
      tradeApplyOrderVO: {},
      tradeApplyInfoVO: "",
      tradeApplyBaseVO: {},
      tradeApplyBizVO: "",
      tradeApplyExecVO: "",
      tradeApplyExecCooler: "",
      tradeApplyExecCustom: "",
      tradeApplyExecStack: "",
      tradeApplyProcessRecordVO: "",
      tradeBmApplyDetailList: "",
      tradeBmApplyImageList: "",
      processRecordList: [],
      ispOrderData: "",
      tradeApplyExecPboDTO: "",
      employeeLevel: null,
      defaultBuType: "",
      vendorList: [],
      execTypeSub: "",

      infoLoading: false,
      btnLoading: false,
      orderShow: true,
      processShow: true,
      planShow: true,
      acceptShow: true,
      quotaShow: true,
      investmentShow: true,
      buQuotaShow: true,

      isMineApproval: false,
      isMineApply: false,
      dialogVisible: false,
      rejectVisiable: false,
      succVisible: false,
      handleType: "",
      handleText: "",
      successText: "",

      // 按钮权限
      canReject: false,
      canPass: false,
      canAccept: false,
      canSupplier: false,
      canReceipt: false,
      supplierSelectShow: false,
      supplierSelectShowOn130: false,

      expenseInfoShow: false,
      budgetSelectShow: false,
      planDetailShow: false,
      acceptDetailShow: false,
      supplementShow: false,

      approvalFormData: {
        applyId: "",
        approvalResult: "", // 01提交，02审批通过，03审批退回
        processRemark: "", // 如驳回，驳回理由
        vendorId: "", // 服务商
        processClientId: "", // 操作人Id
        processClientName: "", // 操作人名字
        trCode: "", // TRCode
        quotaId: "", // 配额ID
        ledgerAccount: "", // 总账科目
        costCenterCode: "", // 成本中心
        mmr12: "", // mmr12
        clientType: "", // 用户类型 01百威 02ISP
        applyType: "", // 对应申请单类型 01高端店招 02物料定制 03批量化物料 04完美门店
        approvalType: "", // 01需求审批 02费用审批 03验收审批
        tradeApplyExecCoolerList: [] // 资产冰柜
      },

      isFixed: true,

      commentVisible: false,
      commentParams: {
        applyId: "",
        qualityScoreValue: "",
        speedScoreValue: "",
        tmComment: ""
      },
      hasComment: false,

      basePocInfo: {},

      tradeApplyOrderPocCheckInfo: {},

      completeStandardDialog: false,
      historyInvestmentInfo: {}
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted () {
    this.init()
    const _self = this
    window.onscroll = function () {
      _self.isFixed = true
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        _self.isFixed = false
      }
    }
  },
  methods: {
    init () {
      this.getOrderInfo()
      this.getSupplier()
      this.tradeApplyApproveInfo()
    },

    //审批通过
    async confirmPass () {
      try {
        this.btnLoading = true
        const { data } = await orderApi.approveCoolerOrder(this.approveParams)
        this.btnLoading = false
        if (data.resultCode === "0") {
          this.dialogVisible = false
        }
      } catch (error) {
        this.btnLoading = false
      }

    },

    //确定驳回
    async confirmReject () {
      try {
        this.btnLoading = true
        const { data } = await orderApi.approveCoolerOrder(this.approveParams)
        this.btnLoading = false
        if (data.resultCode === "0") {
          this.rejectVisiable = false
        }
      } catch (error) {
        this.btnLoading = false
      }
    },

    // 获取订单详情
    /* async getOrderInfo() {
      const { data } = await orderApi.getOrderInfo(this.approveParams.applyId)
      if (data.resultCode === '0') {
        this.orderInfo = data.resultData.tradeApplyOrderVO
        this.mainActive = this.orderInfo.tradeApplyInfoVO.applyStatus
        this.execCoolerTrackVO = this.orderInfo.tradeApplyExecCoolerTrackVO
        this.execCoolerTrackVO.applyNumber = this.orderInfo.tradeApplyInfoVO.applyNumber
        this.afterPocInfo = this.execCoolerTrackVO.afterPocInfo
        this.entryCode = Number(this.orderInfo.tradeApplyExecVO.execTypeSub)
        if (this.entryCode !== 113) {
          this.getPaidAmount()
        }
      }
    }, */

    // 获取订单信息
    getOrderInfo () {
      this.infoLoading = true
      this.$store
        .dispatch("getOrderInfo", this.$route.query.applyId)
        .then(res => {
          this.infoLoading = false
          if (res.data.resultCode === "0") {
            console.log("订单信息-----------------------")

            console.log(res.data.resultData)
            this.tradeApplyOrderVO = res.data.resultData.tradeApplyOrderVO
            this.afterPocInfo = this.tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.afterPocInfo
            this.coolerInfo = this.tradeApplyOrderVO.tradeApplyExecCoolerTrackVO
            this.entryCode = this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub
            this.tradeApplyInfoVO = this.tradeApplyOrderVO.tradeApplyInfoVO
            this.tradeApplyBaseVO = Object.assign(
              {},
              this.tradeApplyOrderVO.basePocInfo,
              this.tradeApplyOrderVO.tradeApplyBaseVO
            )
            this.tradeApplyBizVO =
              this.tradeApplyOrderVO.tradeApplyBizVO ||
              this.tradeApplyOrderVO.basePocInfo
            this.tradeApplyExecVO = this.tradeApplyOrderVO.tradeApplyExecVO
            this.tradeApplyExecCooler = this.tradeApplyOrderVO.tradeApplyExecCooler
            this.tradeApplyExecCustom = this.tradeApplyOrderVO.tradeApplyExecCustom
            this.tradeApplyExecStack = this.tradeApplyOrderVO.tradeApplyExecStack
            this.tradeApplyProcessRecordVO = this.tradeApplyOrderVO.tradeApplyProcessRecordVO
            this.tradeBmApplyDetailList = this.tradeApplyOrderVO.tradeBmApplyDetailList
            this.tradeBmApplyImageList = this.tradeApplyOrderVO.tradeBmApplyImageList
            this.processRecordList =
              this.tradeApplyOrderVO.processRecordList || []
            this.ispOrderData = this.tradeApplyOrderVO.ispOrderData
            this.tradeApplyExecPboDTO = this.tradeApplyOrderVO.tradeApplyExecPboDTO
            this.basePocInfo = this.tradeApplyOrderVO.basePocInfo
            if (this.entryCode == '111' || this.entryCode == '113') {
              this.$nextTick(() => {
                this.$refs.StoreCoolerInfo.initMap(this.basePocInfo)
              })
            }




            // 审批人是否是本人   //当前状态是否为待审批
            if (
              this.userInfo.clientId ==
              this.tradeApplyOrderVO.tradeApplyInfoVO.approvalClientId &&
              this.tradeApplyOrderVO.tradeApplyInfoVO.applyStatus == "100"
            ) {
              this.showButton = true
            } else {
              this.showButton = false
            }

            // 进度条
            this.$refs.OrderStepInfo.setOrderStatusList(this.tradeApplyOrderVO)

            // 审批概览
            // this.$refs.OrderExpenseInfo.setExpenseInfo(this.tradeApplyOrderVO)

            // 方案明细
            this.$refs.OrderPlanDetail.setPlanInfo(this.tradeApplyInfoVO)

            // 验收详情
            this.$refs.OrderAcceptDetail.setAcceptInfo(this.tradeApplyOrderVO)

            // 评价
            if (this.tradeApplyInfoVO.tradeApplyEvaluateDTO) {
              this.$refs.OrderCommentInfo.setCommentInfo(
                this.tradeApplyInfoVO.tradeApplyEvaluateDTO
              )
            }

            this.defaultBuType = this.userInfo.defaultBuType
            this.employeeLevel = this.userInfo.employeeLevel

            // 门店完美门店参与资格
            if (this.tradeApplyExecStack) {
              this.tradeApplyBaseVO.isStack = Boolean(
                this.tradeApplyBaseVO.isStack
              )
            }

            // 门店PBO计划参与资格
            if (this.tradeApplyExecPboDTO) {
              this.tradeApplyExecPboDTO.attendStatus = Boolean(
                this.tradeApplyExecPboDTO.attendStatus
              )
            }

            // 选项权限
            this.setSelectAuth()
            // 按钮权限
            this.setBtnAuth()
            // 审批详情权限
            this.setDetailAuth()
          }
        })
        .catch(() => {
          this.infoLoading = false
        })
    },

    // 获取供应商列表
    getSupplier () {
      const params = {
        vendorName: ""
      }
      this.$store.dispatch("getSupplier", params).then(res => {
        if (res.data.resultCode === "0") {
          this.vendorList = res.data.resultData.vendorList || []
        }
      })
    },

    // 设置选项显示
    setSelectAuth () {
      this.expenseInfoShow = false
      this.budgetSelectShow = false
      this.supplementShow = false

      const solutionStatus = this.tradeApplyInfoVO.solutionStatus
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      const acceptanceStatus = this.tradeApplyInfoVO.acceptanceStatus

      // 预算
      if (
        this.isMineApproval &&
        (((this.employeeLevel === 50 || this.employeeLevel === 45) &&
          applyStatus === "200" &&
          solutionStatus === "250") ||
          (this.tradeApplyInfoVO.applyClientLevel === 60 &&
            this.employeeLevel === 60 &&
            solutionStatus === "270")) &&
        applyStatus === "200"
      ) {
        this.budgetSelectShow = true
      }

      // 审批概览显示
      if (
        applyStatus === "200" &&
        (solutionStatus === "210" || Number(solutionStatus) >= 250)
      ) {
        this.expenseInfoShow = true
      }

      // 补充信息显示
      if (this.tradeApplyOrderVO.applyType !== "02") {
        if (
          (this.isMineApply ||
            this.employeeLevel === 45 ||
            this.employeeLevel === 50 ||
            (this.defaultBuType === "03" && this.employeeLevel === 60)) &&
          Number(acceptanceStatus) < 420 &&
          (!this.tradeApplyBizVO.dianpinImage ||
            !this.tradeApplyBizVO.wccsId) &&
          applyStatus !== "900" &&
          applyStatus !== "0" &&
          !this.tradeApplyExecCooler &&
          !this.tradeApplyExecStack
        ) {
          this.supplementShow = true
        }
      } else {
        this.supplementShow = false
      }
    },

    // 设置按钮权限
    setBtnAuth () {
      this.canReject = false
      this.canPass = false
      this.canAccept = false
      this.canSupplier = false
      this.canReceipt = false
      this.supplierSelectShow = false
      this.supplierSelectShowOn130 = false
      // 驳回
      if (!this.tradeApplyExecStack) {
        // 非堆箱
        if (
          this.tradeApplyInfoVO.solutionStatus !== "210" &&
          this.tradeApplyInfoVO.acceptanceStatus !== "450" &&
          this.tradeApplyInfoVO.acceptanceStatus !== "410"
        ) {
          this.canReject = true
        }
      } else {
        // 堆箱
        if (
          this.tradeApplyInfoVO.requirementStatus === "120" ||
          this.tradeApplyInfoVO.requirementStatus === "130"
        ) {
          this.canReject = true
          this.canPass = true
        }
      }

      // 通过
      if (!this.tradeApplyExecStack) {
        // 非堆箱
        if (
          this.tradeApplyInfoVO.solutionStatus !== "210" &&
          this.tradeApplyInfoVO.applyStatus !== "400"
        ) {
          this.canPass = true
        }
      }

      // 验收
      if (
        this.tradeApplyInfoVO.solutionStatus !== "210" &&
        this.tradeApplyInfoVO.applyStatus === "400" &&
        this.tradeApplyInfoVO.acceptanceStatus === "420"
      ) {
        this.canAccept = true
      }

      // 提交供应商
      // 百威： 高端店招、物料定制 状态130/210，角色为45TM助理/50TM；
      // ISP： 303物料定制 状态140 角色60 BUISPTM； 301高端执行、302形象店 状态130 角色60 BUISPTM
      let execTypeSub = ""
      if (this.tradeApplyOrderVO.tradeApplyExecVO) {
        execTypeSub = this.tradeApplyOrderVO.tradeApplyExecVO.execTypeSub
      }
      if (
        this.tradeApplyOrderVO.applyType === "01" &&
        (this.employeeLevel === 45 || this.employeeLevel === 50) &&
        (this.tradeApplyExecVO || this.tradeApplyExecCustom) &&
        !this.tradeApplyExecCooler
      ) {
        if (
          this.tradeApplyInfoVO.applyStatus === "100" &&
          this.tradeApplyInfoVO.requirementStatus === "130"
        ) {
          this.supplierSelectShowOn130 = true
          this.canPass = true
        }
        if (this.tradeApplyInfoVO.solutionStatus === "210") {
          this.canSupplier = true
          this.canPass = false
        }
      } else if (
        this.tradeApplyOrderVO.applyType === "03" &&
        this.tradeApplyInfoVO.applyStatus === "100" &&
        !this.tradeApplyInfoVO.vendorName
      ) {
        if (
          execTypeSub === "303" &&
          this.tradeApplyInfoVO.requirementStatus === "140" &&
          this.employeeLevel === 60
        ) {
          this.supplierSelectShow = true
          this.canPass = false
        } else if (
          this.tradeApplyInfoVO.requirementStatus === "130" &&
          (this.employeeLevel === 45 || this.employeeLevel === 50)
        ) {
          this.supplierSelectShow = true
          this.canPass = false
        }
      }

      // 确认收货
      if (
        (this.employeeLevel === 45 ||
          this.employeeLevel === 50 ||
          this.employeeLevel === 60) &&
        this.tradeApplyInfoVO.acceptanceStatus === "450"
      ) {
        this.canReceipt = true
      }
    },

    // 设置审批详情权限
    setDetailAuth () {
      this.planDetailShow = false
      this.acceptDetailShow = false

      if (this.tradeApplyOrderVO.applyType !== "03") {
        if (
          Number(this.tradeApplyInfoVO.solutionStatus) >= 220 &&
          !this.tradeApplyExecCooler
        ) {
          this.planDetailShow = true
        }
      } else {
        if (
          Number(this.tradeApplyInfoVO.requirementStatus) >= 140 &&
          this.tradeApplyInfoVO.vendorName
        ) {
          this.planDetailShow = true
        }
      }

      if (
        Number(this.tradeApplyInfoVO.acceptanceStatus) >= 420 &&
        !this.tradeApplyExecCooler &&
        this.employeeLevel >= 40
      ) {
        this.acceptDetailShow = true
      }
    },

    // 驳回
    handleReject () {
      this.rejectVisiable = true
      this.approveParams.applyId = this.tradeApplyOrderVO.applyId
      this.approveParams.approvalResult = "03"
      this.approveParams.processRemark = ""
    },

    // 通过
    handlePass () {
      if (this.basePocInfo.abiPocId && this.basePocInfo.abiPocStatus === 2 && this.entryCode != '112') {
        this.$confirm('单据无法通过，该门店已永久关店。请驳回单据，驳回后订单将自动关闭。', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '驳回',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.handleType = 'reject'
              this.handleConfirm(true)
            }
          }
        })
        return
      }
      this.dialogVisible = true
      this.approveParams.applyId = this.tradeApplyOrderVO.applyId
      this.approveParams.approvalResult = "02"
      this.approveParams.processRemark = ""
    },

    // 验收
    handleAccept () {
      if (!this.tradeApplyInfoVO.tradeApplyEvaluateDTO && !this.hasComment) {
        this.$refs.OrderCommentDialog.commentShow()
        return
      }
      this.dialogVisible = true
      this.handleText = ""
      this.handleType = "accept"
    },

    // 提交供应商
    handleSupplier () {
      if (
        this.tradeApplyExecVO?.execTypeSub === "101" ||
        this.tradeApplyExecCustom?.execTypeSub === "201"
      ) {
        if (!this.approvalFormData.vendorId) {
          this.$message.error("请选择服务商")
          return
        }
        this.handleText = "是否确认分配该服务商?"
      } else {
        this.handleText = ""
      }

      this.dialogVisible = true
      this.handleType = "supplier"
    },

    // 确认收货
    handleReceipt () {
      this.dialogVisible = true
      this.handleType = "receipt"
      this.handleText = "是否确认收货?"
    },

    // 弹窗确认
    handleConfirm (notCheckRemark) {
      if (this.btnLoading) {
        return
      }

      let approvalType = ""
      const applyStatus = this.tradeApplyInfoVO.applyStatus
      if (applyStatus === "100") approvalType = "01"
      if (applyStatus === "200") approvalType = "02"
      if (applyStatus === "400") approvalType = "03"

      this.approvalFormData.applyId = this.tradeApplyOrderVO.applyId
      this.approvalFormData.approvalType = approvalType
      this.approvalFormData.processClientId = this.userInfo.clientId
      this.approvalFormData.processClientName = this.userInfo.clientName

      // 审批驳回
      if (this.handleType === "reject") {
        this.successText = "订单驳回成功"

        if (!this.approvalFormData.processRemark && !notCheckRemark) {
          this.$message.error("请填写驳回理由")
          return
        }
        this.approvalFormData.approvalResult = "03"
      }

      // 审批通过
      if (this.handleType === "pass") {
        this.successText = "订单审批成功"
        this.approvalFormData.type = '02'

        // 选择服务商
        if (
          this.supplierSelectShow &&
          this.tradeApplyOrderVO.applyType === "03" &&
          !this.approvalFormData.vendorId
        ) {
          this.$message.error("请选择服务商")
          return
        }

        // 选择预算
        if (this.budgetSelectShow) {
          if (!this.approvalFormData.trCode && !this.approvalFormData.quotaId) {
            this.$message.error("请选择TRcode")
            return
          }
          if (!this.approvalFormData.mmr12) {
            this.$message.error("请选择MMR12")
            return
          }
          if (!this.approvalFormData.costCenterCode) {
            this.$message.error("请选择成本中心")
            return
          }
          if (!this.approvalFormData.ledgerAccount) {
            this.$message.error("请选择总账科目")
            return
          }
        }

        this.approvalFormData.tradeApplyExecCoolerList = []

        this.approvalFormData.approvalResult = "02"
      }

      // 审批验收
      if (this.handleType === "accept") {
        this.successText = "订单验收成功"
        this.approvalFormData.approvalResult = "02"
      }

      // 分配服务商
      if (this.handleType === "supplier") {
        if (!this.approvalFormData.vendorId) {
          this.$message.error("请选择服务商")
          return
        }
        this.successText = "分配服务商成功"
        if (this.tradeApplyOrderVO.applyType !== "03") {
          this.btnLoading = true
          this.$store
            .dispatch("submitSupplier", this.approvalFormData)
            .then(res => {
              this.btnLoading = false
              if (res.data.resultCode === "0") {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
          return
        } else {
          this.approvalFormData.approvalResult = "02"
          this.successText = "分配服务商成功"
        }
      }

      // 确认收货
      if (this.handleType === "receipt") {
        const formData = {
          applyId: this.tradeApplyOrderVO.applyId
        }
        this.successText = "收货成功"
        this.btnLoading = true
        this.$store
          .dispatch("handleReceipt", formData)
          .then(res => {
            this.btnLoading = false
            if (res.data.resultCode === "0") {
              this.dialogVisible = false
              this.succVisible = true
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
        return
      }

      // 调用接口
      if (this.tradeApplyOrderVO.applyType !== "03") {
        if (
          this.tradeApplyOrderVO.applyType === "02" &&
          this.tradeApplyInfoVO.clientType === "02"
        ) {
          // isp批量化物料
          this.btnLoading = true
          this.$store
            .dispatch("handleIspApprove", this.approvalFormData)
            .then(res => {
              this.btnLoading = false
              if (res.data.resultCode === "0") {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else if (this.tradeApplyOrderVO.applyType === "04") {
          // pbo
          this.btnLoading = true
          const data = {
            applyId: this.approvalFormData.applyId,
            approvalResult: this.approvalFormData.approvalResult,
            processRemark: this.approvalFormData.processRemark
          }
          this.$store
            .dispatch("handlePboApprove", data)
            .then(res => {
              this.btnLoading = false
              if (res.data.resultCode === "0") {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        } else {
          // 百威
          this.btnLoading = true
          this.$store
            .dispatch("handleApprove", this.approvalFormData)
            .then(res => {
              this.btnLoading = false
              if (res.data.resultCode === "0") {
                this.dialogVisible = false
                this.succVisible = true
              }
            })
            .catch(() => {
              this.btnLoading = false
            })
        }
      } else {
        // ISP
        this.btnLoading = true
        this.$store
          .dispatch("handleIspApprove", this.approvalFormData)
          .then(res => {
            this.btnLoading = false
            if (res.data.resultCode === "0") {
              this.dialogVisible = false
              this.succVisible = true
            }
          })
          .catch(() => {
            this.btnLoading = false
          })
      }
    },

    // 返回订单列表
    returnList () {
      this.$router.go(-1)
    },

    // 查看详情
    showInfo () {
      this.succVisible = false
      this.init()
    },

    collClick (index) {
      if (!index) {
        this.orderShow = !this.orderShow
      } else if (index === 1) {
        this.processShow = !this.processShow
      } else if (index === 2) {
        this.planShow = !this.planShow
      } else if (index === 3) {
        this.acceptShow = !this.acceptShow
      } else if (index === 4) {
        this.quotaShow = !this.quotaShow
      } else if (index === 5) {
        this.investmentShow = !this.investmentShow
      } else if (index === 6) {
        this.buQuotaShow = !this.buQuotaShow
      }
    },

    // 门店完美门店参与资格
    stackSwitch () {
      if (this.tradeApplyBaseVO.isStack) {
        this.$confirm("请确认是否关闭门店完美门店参与资格", "提示", {
          showCancelButton: true,
          cancelButtonText: "暂不关闭",
          confirmButtonText: "残忍关闭"
        }).then(() => {
          this.$confirm("请确认是否关闭门店完美门店参与资格", "提示", {
            showCancelButton: true,
            cancelButtonText: "暂不关闭",
            confirmButtonText: "残忍关闭"
          }).then(() => {
            this.$store
              .dispatch("setTrade", this.tradeApplyInfoVO.applyNumber)
              .then(res => {
                if (res.data.resultCode === "0") {
                  this.init()
                }
              })
          })
        })
      } else {
        if (this.employeeLevel !== 50) {
          return
        }
        this.$confirm("请确认是否开启门店堆箱计划参与资格", "提示", {
          showCancelButton: true,
          cancelButtonText: "暂不开启",
          confirmButtonText: "确认开启"
        }).then(() => {
          this.$store
            .dispatch("enableTrade", this.tradeApplyInfoVO.applyNumber)
            .then(res => {
              if (res.data.resultCode === "0") {
                this.init()
              }
            })
        })
      }
    },

    // PBO参与资格
    pboSwitch () {
      const params = {
        applyId: this.tradeApplyInfoVO.applyId
      }
      if (this.tradeApplyExecPboDTO.attendStatus) {
        this.$confirm("请确认是否禁用该PBO计划", "提示", {
          showCancelButton: true,
          cancelButtonText: "暂不禁用",
          confirmButtonText: "残忍禁用"
        }).then(() => {
          this.$confirm("请确认是否禁用该PBO计划", "提示", {
            showCancelButton: true,
            cancelButtonText: "暂不禁用",
            confirmButtonText: "残忍禁用"
          }).then(() => {
            this.$store.dispatch("disablePbo", params).then(res => {
              if (res.data.resultCode === "0") {
                this.init()
              }
            })
          })
        })
      } else {
        if (this.employeeLevel !== 30) {
          return
        }
        this.$confirm("请确认是否开启该PBO计划", "提示", {
          showCancelButton: true,
          cancelButtonText: "暂不开启",
          confirmButtonText: "确认开启"
        }).then(() => {
          this.$store.dispatch("enablePbo", params).then(res => {
            if (res.data.resultCode === "0") {
              this.init()
            }
          })
        })
      }
    },

    qualityClick (val) {
      this.commentParams.qualityScoreValue = val
    },

    speedClick (val) {
      this.commentParams.speedScoreValue = val
    },

    commentSuccess () {
      this.hasComment = true
      this.handleAccept()
    },
    tableBorderRight ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3) {
        return "border-right:1px solid #EBEEF5;"
      }
    },
    // 门店选店标准审核检查
    tradeApplyApproveInfo () {
      this.$store
        .dispatch("tradeApplyApproveInfo", this.$route.query.applyId)
        .then(res => {
          if (res.data.resultCode === "0") {
            this.tradeApplyOrderPocCheckInfo =
              res.data.resultData.tradeApplyOrderVO.tradeApplyOrderPocCheckResultMap
            this.historyInvestmentInfo = res.data.resultData.reportMap
          }
        })
    },
    // 门店校验标准信息
    // getApprovePocCheckStandard (type) {
    //   this.$store.dispatch('getApprovePocCheckStandard', type).then(res => {
    //     if (res.data.resultCode === '0') {
    //       if (type === '102') {
    //         let obj = res.data.resultData.pocStandardResultMap
    //         let info = {}
    //         for (const i in obj) {
    //           obj[i].forEach(item => {
    //             item.coolerName = item.channelCode
    //             if (!info[item.channelCode]) {
    //               info[item.channelCode] = [item]
    //             } else {
    //               info[item.channelCode].push(item)
    //             }
    //           })
    //         }
    //         let list = []
    //         for (const i in info) {
    //           list.push(info[i])
    //         }
    //         this.completeStandardInfo = list.flat()
    //       } else {
    //         this.completeStandardInfo = res.data.resultData.pocStandardResultMap['普通']
    //       }
    //     }
    //   })
    // },
    // 判断门店是否符合所有标准
    checkStandardAll (list) {
      return list.every(item => {
        return item.isMatch === 1
      })
    },
    showCompleteStandard () {
      this.completeStandardDialog = true
    },
    // 表格样式
    tableHeaderRowClassName ({ rowIndex }) {
      if (rowIndex === 0) {
        return "quota-table-row-0"
      }
      if (rowIndex === 1) {
        return "quota-table-row-1"
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.color-red {
  color: $base-red;
  & > div {
    margin: 5px 0;
  }
}
.dialog-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    margin: 10px 0;
    font-weight: 700;
  }
}

::v-deep .el-dialog {
  min-width: 430px;
}
.content-container {
  padding-bottom: 20px;
}
.info-title {
  font-size: $font-16;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 10px;

  i {
    font-weight: bold;
  }
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  line-height: 100px;
  background: #f3f5f9;
  z-index: 10;
}
.info-btn {
  text-align: center;
  height: 42px;
  .el-button {
    padding-left: 40px;
    padding-right: 40px;
    margin: 10px 25px 0 25px;
  }
}

.block-content {
  line-height: 30px;
}

::v-deep .el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: pointer !important;
}

::v-deep .el-switch.is-disabled {
  opacity: 1;
}
.el-table ::v-deep .el-table__cell {
  // border-right: 0px;
}
.standard-title {
  font-size: 0px;
  color: #cacbca;
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: inline-block;
  line-height: 18px;
  img {
    width: 100%;
  }
}
.investment-table {
  width: 100%;
  border: 1px solid #ebeef5;
  border-radius: 5px;
  margin-top: 30px;
  border-collapse: collapse;
  line-height: 23px;
  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    img {
      width: 100%;
    }
  }
  th {
    padding: 12px 0;
    background: #f5f7fa;
    color: rgb(56, 55, 55);
  }
  td {
    // width: 130px;
    text-align: center;
    border: 1px solid #ebeef5;
    padding: 12px 0;
    box-sizing: border-box;
    color: #606266;
    &:nth-child(1) {
      width: 205px;
    }
    &:nth-child(2) {
      width: 400px;
    }
    &:nth-child(3) {
      width: 400px;
    }
    &:nth-child(2) {
      width: 400px;
    }
  }
  .isMeet {
    color: #3faa1d;
  }
  .Meet {
    color: #f29613;
  }
}
</style>
<style lang="scss">
.el-message-box .el-message-box__btns {
  margin-top: 20px;
  text-align: center;
  .el-button--primary {
    background-color: #c8102d;
    border-color: #c8102d;
  }
}
.el-message-box__wrapper {
  bottom: 350px;
}
.history-investment-box {
  display: flex;
  text-align: center;
  border: 1px solid #ebeef5;
  margin-top: 20px;
  border-radius: 5px;
  .history-investment {
    border-right: 1px solid #ebeef5;
    flex: 1;
    .investment-title {
      font-size: 18px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0 10px;
      border-bottom: 1px solid #ebeef5;
      span {
        &:last-child {
          color: #c8102d;
          font-weight: 700;
          line-height: 35px;
        }
      }
    }
    .investment-content {
      padding: 0 60px;
      div {
        display: flex;
        justify-content: space-around;
        padding: 16px 0;
      }
    }
  }
}
.trade-order-block .content-row {
  margin-top: 15px;
}
</style>
<style lang="scss">
.complete-standard-info {
  img {
    width: 100%;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
}
// .el-table thead.is-group th.el-table__cell{
//   background-color: #fff;
// }
.quota-table-row-0 th {
  border-right: 0 !important;
  color: rgb(56, 55, 55);
}
.quota-table-row-1 th {
  // color: red;
  background-color: #fff !important;
}
// .quota-table-row th.el-table__cell{
//       //  background-color: #fff;
// }
</style>
